<template>
    <div>
       <AlertDismiss ref="alertDismiss"></AlertDismiss>
        <b-form @submit.prevent="onSubmit">
            <div class="row">
                <div class="col-md-6 mb-3">
                    <b-form-group label="Nombre">
                        <b-form-input
                            v-model="name"
                            :state="validate(name)"
                        />
                    </b-form-group>
                </div>
                <div class="col-md-6 mb-3">
                    <RUTInput v-model="rut" :state="validate(rut)"></RUTInput>
                </div>
                <div class="col-md-6 mb-3">
                    <b-form-group label="Tipo de persona">
                        <div class="row">
                            <div class="col-auto">
                                <b-form-radio v-model="isNaturalPerson" :value="true">
                                    <span class="ms-2">Natural</span>
                                </b-form-radio>
                            </div>
                            <div class="col-auto">
                                <b-form-radio v-model="isNaturalPerson" :value="false">
                                    <span class="ms-2">Jurídica</span>
                                </b-form-radio>
                            </div>
                        </div>
                    </b-form-group>
                </div>
                    <div class="col-md-6" v-show="!isNaturalPerson">
                        <hr/>
                        <div class="mb-3">
                            <b-form-group label="Número de socios" >
                                <b-form-input
                                    v-model="numberOfShareholders"
                                    :state="validate(numberOfShareholders)"
                                />
                            </b-form-group>
                        </div>
                        <div class="mb-3">
                            <label for="fileInput">Archivo</label>
                            <input 
                                type="file" 
                                :class="fileClass"  
                                id="fileInput" 
                                ref="fileInput" 
                                @change="handleFileChange" 
                                accept=".pdf,application/pdf"
                            />
                        </div>
                        <div>
                            <b-form-checkbox v-model="isManagedCompany">
                                <span class="ms-2">
                                    Es compañia administrada
                                </span>
                            </b-form-checkbox>
                        </div>
                    </div>
                </div>
            <div class="row">
                <div class="col-6 col-sm-2 align-items-center">
                    <b-button type="submit" variant="outline-primary" :disabled="isUploading">
                        <b-spinner small v-show="isUploading"></b-spinner>
                        Crear
                    </b-button>
                </div>
                <div class="col-6 col-sm-10" v-show="showProgress">
                    <ProgressCustom ref="progressCustom"></ProgressCustom>
                </div>
            </div>
        </b-form>
    </div>
</template>
<script>
import RUTInput from "@/components/shared/RUT-input.vue";
import { mapActions } from 'vuex';
import AlertDismiss from "@/components/shared/Alert-dismiss.vue";
import { EventNames } from "@/plugins/enums";
import ProgressCustom from "@/components/shared/Progress-custom.vue";
export default {
    name: 'ManagedCompaniesForm',

    components: {
        ProgressCustom,
        AlertDismiss,
        RUTInput
    },

    data() {
        return {
            name: "",
            rut: "",
            legalDocument: null,
            isNaturalPerson: true,
            isManagedCompany: false,
            numberOfShareholders: null,

            documentId: null,

            isUploading: false,
            attemptedSubmit: false,
            showProgress: false
        }
    },

    computed: {
        fileClass() {
            let valid = this.attemptedSubmit && !this.legalDocument ? 'is-invalid' : ''
            return 'form-control mt-2 ' + valid
        }
    },

    methods: {
        ...mapActions(['createCompany', 'createSubject', 'updateCompanyDocument']),

        async onSubmit() {
            this.isUploading = true;
            // we only show progress bar when uploading a document, otherwise is distracting
            if (this.legalDocument !== null) {
                this.showProgress = true;
                await this.uploadDocument()
            }
            await this.saveForm()

            this.isUploading = false;
        },

        async saveForm() {
            let result;
            if (this.isNaturalPerson) {
                let data = {
                    name: this.name,
                    rut: this.rut,
                }
                result = await this.createSubject(data);

            } else {
                this.$refs.progressCustom.progress(85, 'Subiendo información de la sociedad...');

                let data = {
                    companyName: this.name,
                    rut: this.rut,
                    type: this.isManagedCompany ? "managedCompany" : "company",
                    maximumNumberOfPartners: this.numberOfShareholders,
                }

                if (this.legalDocument !== null) {
                    data.documentRequest = {
                        documentRoute: this.documentId,
                        documentName: this.legalDocument.name,
                    }
                }

                result = await this.createCompany(data);
            }

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, 'danger');
                this.$refs.progressCustom.progress(0);
                this.showProgress = false;
                this.isUploading = false;
                this.attemptedSubmit = true;
                return;
            }

            this.$refs.progressCustom.progress(100, 'Proceso completado');
            this.$refs.alertDismiss.showAlert(
                (this.isNaturalPerson ? 'Persona' : 'Empresa') + ' creada correctamente',
                'success'
            );
            this.$eventBus.$emit(EventNames.UpdateLegalEntities)
            this.clear()
            setTimeout(() => {
                this.showProgress = false;
            }, 1000);
        },

        async uploadDocument() {
            if (this.documentId) {
                this.$refs.progressCustom.progress(70, 'Usando documento cargado anteriormente...');
                return;
            }

            this.$refs.progressCustom.progress(5, 'Cargando documento...');

            let result = await this.updateCompanyDocument(this.legalDocument);
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message, 'danger');
                this.$refs.progressCustom.progress(0 );
                return;
            }

            this.$refs.alertDismiss.showAlert('Documento subido correctamente', 'success');
            this.$refs.progressCustom.progress(70, 'Documento subido correctamente');

            this.documentId = result.data
        },

        clear() {
            this.name = "";
            this.rut = "";
            this.legalDocument = null;
            this.numberOfShareholders = null;
            this.attemptedSubmit = false;
            this.documentId = null;
            this.$refs.fileInput = null
        },

        validate(value) {
            if (this.attemptedSubmit && !value) {
                return false;
            }
            return null
        },

        handleFileChange(event) {
          const file = event.target.files[0]
          if (file) {
            this.legalDocument = file
          }
        },
    }
}
</script>
<style scoped>
a {
    margin-bottom: 1rem;
}
</style>
